import httpService from '@Utils/httpService';

const baseUrl = 'api/Releases';

export default {
  // params: { page, itemsPerPage }
  get(params) {
    return httpService.get({
      url: baseUrl,
      params,
    });
  },
  getBySlug(slug) {
    return httpService.get({
      url: `${baseUrl}/${slug}`,
    });
  },
  getSubscription() {
    return httpService.get({
      url: `${baseUrl}/subscription`,
    });
  },
  updateSubscription(data) {
    return httpService.put({
      url: `${baseUrl}/subscription`,
      data,
    });
  },
};
